module.exports = "../fonts/Futura-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./@fonts/futura/Futura-Bold.woff
// module id = 516
// module chunks = 7